import "./Prima.scss";
import primaLogo from "../assets/template/prima-logo.svg";
import {Box} from "@chakra-ui/react";

function PrimaTemplate(props) {
    return (
        <div className={"page prima"}>
            <Box className="template-header-bar" mb={[2,5]}>
                <div className={"logo"}>
                    <img width={"250"} src={primaLogo} alt={"prima-logo"}/>
                </div>
            </Box>

            {props.children}
        </div>
    );
}

export default PrimaTemplate;
